var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNgn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_284_131544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.938 0.536662C22.3139 0.537103 22.6743 0.66175 22.9401 0.88326C23.2059 1.10477 23.3555 1.40508 23.356 1.71834V18.2817C23.3555 18.5949 23.2059 18.8952 22.9401 19.1167C22.6743 19.3382 22.3139 19.4629 21.938 19.4633H2.06201C1.6861 19.4629 1.32572 19.3382 1.05991 19.1167C0.7941 18.8952 0.644523 18.5949 0.643994 18.2817V1.71834C0.644523 1.40508 0.7941 1.10477 1.05991 0.88326C1.32572 0.66175 1.6861 0.537103 2.06201 0.536662H21.938ZM21.938 0H2.06201C1.5153 0.000441254 0.991126 0.18163 0.604541 0.503784C0.217956 0.825939 0.000529505 1.26275 0 1.71834V18.2817C0.000529505 18.7373 0.217956 19.1741 0.604541 19.4962C0.991126 19.8184 1.5153 19.9996 2.06201 20H21.938C22.4845 19.9991 23.0084 19.8178 23.3949 19.4957C23.7814 19.1737 23.9989 18.7371 24 18.2817V1.71834C23.9995 1.26275 23.782 0.825939 23.3955 0.503784C23.0089 0.18163 22.4847 0.000441254 21.938 0Z",
    fill: "#CAB99E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4534 0H17V20H22.4534C22.8634 19.9995 23.2565 19.8678 23.5464 19.6337C23.8363 19.3997 23.9994 19.0823 24 18.7513V1.24869C23.9994 0.917667 23.8363 0.600325 23.5464 0.366254C23.2565 0.132182 22.8634 0.000465908 22.4534 0Z",
    fill: "#00874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5466 0C1.1366 0.000465908 0.743549 0.132182 0.453633 0.366254C0.163718 0.600325 0.000577062 0.917667 0 1.24869V18.7513C0.000577062 19.0823 0.163718 19.3997 0.453633 19.6337C0.743549 19.8678 1.1366 19.9995 1.5466 20H7V0H1.5466Z",
    fill: "#00874C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 0H7V20H17V0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_284_131544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNgn);
export default __webpack_public_path__ + "static/media/ngn.33dc28420e416198e882136f96cc3841.svg";
export { ForwardRef as ReactComponent };